module.exports = __webpack_public_path__ + "static/media/TRIAL 2.5a45fca7.mp3";